import {
    apiRequest,
    presensiDetail,
    presensiListPresensi,
    presensiupdate,
    presensiExport,
    bknServiceIdentitas,
    bknServiceJabatan,
    bknServiceSendJabatan,
    bknServiceTakeJabatan,
    bknServiceDownloadFile,
    diklatList
} from "../../../../../services/adapters/kepegawaian/integrasiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", presensiDetail, {
            params: query
        }, true)
    }

    fetchListPresensi = async (query) => {
        return await apiRequest("get", presensiListPresensi, {
            params: query
        }, true)
    }

    fetchUpdatePresensi = async (query) => {
        return await apiRequest("post", presensiupdate, {
            params: query
        }, true)
    }
    fetchExport = async (query) => {
        return await apiRequest("get", presensiExport, {
            params: query
        }, true)
    }

    BKNServiceIdentitas = async (query) => {
        return await apiRequest("get", bknServiceIdentitas, {
            params: query
        }, true)
    }
    BKNServiceJabatan = async (query) => {
        return await apiRequest("get", bknServiceJabatan, {
            params: query
        }, true)
    }

    sendToBKN = async (query) => {
        return await apiRequest("get", bknServiceSendJabatan, {
            params: query
        }, true)
    }
    downloadFile = async (query) => {
        return await apiRequest("get", bknServiceDownloadFile, {
            params: query
        }, true)
    }
    
    sendToSIMPEG = async (query) => {
        return await apiRequest("get", bknServiceTakeJabatan, {
            params: query
        }, true)
    }
    
    fetchListDiklat = async (query) => {
        return await apiRequest("get", diklatList, {
            params: query
        }, true)
    }
    
}

export default DetailRepository